var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_86055",
    "data-name": "Group 86055",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20.985,
    height: 24.69,
    viewBox: "0 0 20.985 24.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25105",
    "data-name": "Rectangle 25105",
    width: 20.985,
    height: 24.69,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_86054",
    "data-name": "Group 86054",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_242426",
    "data-name": "Path 242426",
    d: "M9.115,24.69a17.187,17.187,0,0,1-8.582-2.3,1.067,1.067,0,0,1-.39-1.458c.008-.013.015-.026.023-.038A1.066,1.066,0,0,1,1.6,20.544a15.1,15.1,0,0,0,15.027,0A1.067,1.067,0,0,1,17.7,22.392a17.19,17.19,0,0,1-8.582,2.3M1.067,21.172a.3.3,0,0,0-.3.3.282.282,0,0,0,.009.071.286.286,0,0,0,.138.184,16.4,16.4,0,0,0,16.393,0,.29.29,0,0,0,.138-.184.3.3,0,0,0-.436-.327,15.884,15.884,0,0,1-15.8,0,.3.3,0,0,0-.149-.04",
    fill: "#515255",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242427",
    "data-name": "Path 242427",
    d: "M14.182,17.525h-9.3a1.756,1.756,0,0,1-1.72-1.4l-2-9.793a1.364,1.364,0,0,1,2.671-.552v.007L5.675,14.8h8.506a1.364,1.364,0,0,1,0,2.728ZM2.5,5.464a.593.593,0,0,0-.581.711l2,9.792a.986.986,0,0,0,.963.786h9.3a.592.592,0,1,0,0-1.184H5.362a.385.385,0,0,1-.378-.308l-1.9-9.323a.593.593,0,0,0-.254-.376.6.6,0,0,0-.327-.1",
    fill: "#515255",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242428",
    "data-name": "Path 242428",
    d: "M3.81,22.339a.386.386,0,0,1-.34-.569l2.592-4.813a.386.386,0,0,1,.68.366L4.15,22.136A.387.387,0,0,1,3.81,22.339Z",
    fill: "#515255",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242429",
    "data-name": "Path 242429",
    d: "M15.02,22.149a.387.387,0,0,1-.339-.2l-2.526-4.623a.386.386,0,1,1,.674-.376l0,.005,2.525,4.624a.385.385,0,0,1-.154.523.372.372,0,0,1-.184.048",
    fill: "#515255",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242430",
    "data-name": "Path 242430",
    d: "M15.16,11.93a.384.384,0,0,1-.3-.14l-.393-.473a1.6,1.6,0,0,0-1.233-.58H4.376a.386.386,0,1,1,0-.771h8.861a2.364,2.364,0,0,1,1.827.858l.393.474a.386.386,0,0,1-.051.543A.381.381,0,0,1,15.16,11.93Z",
    fill: "#515255",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242431",
    "data-name": "Path 242431",
    d: "M12.352,15.569h-4a.386.386,0,0,1-.386-.386V10.352a.385.385,0,0,1,.386-.385h4a.385.385,0,0,1,.386.385v4.831A.386.386,0,0,1,12.352,15.569ZM8.735,14.8h3.232v-4.06H8.735Z",
    fill: "#515255",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242432",
    "data-name": "Path 242432",
    d: "M10.35,10.738a.386.386,0,0,1-.386-.386V2.172a.385.385,0,0,1,.386-.385h2.586a.386.386,0,1,1,0,.771h-2.2v7.794a.386.386,0,0,1-.386.386",
    fill: "#515255",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242433",
    "data-name": "Path 242433",
    d: "M20.6,14.066H12.352a.386.386,0,1,1,0-.772h7.861V2.558h-2.2a.386.386,0,1,1,0-.771H20.6a.385.385,0,0,1,.386.385V13.68a.385.385,0,0,1-.385.386Z",
    fill: "#515255",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242434",
    "data-name": "Path 242434",
    d: "M18.013,3.86H12.936a.386.386,0,0,1-.386-.386V1.8a.836.836,0,0,1,.835-.835h.352V.386A.385.385,0,0,1,14.122,0h2.7a.387.387,0,0,1,.386.386V.968h.352A.836.836,0,0,1,18.4,1.8v1.67a.385.385,0,0,1-.384.387h0m-4.691-.772h4.305V1.8a.063.063,0,0,0-.063-.063h-.737a.387.387,0,0,1-.386-.386V.772H14.509v.582a.386.386,0,0,1-.386.386h-.737a.063.063,0,0,0-.063.063Z",
    fill: "#515255",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242435",
    "data-name": "Path 242435",
    d: "M18.631,6.318H14.8a.386.386,0,0,1,0-.772h3.836a.386.386,0,0,1,0,.772",
    fill: "#ff6464",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242436",
    "data-name": "Path 242436",
    d: "M12.638,6.5a.388.388,0,0,1-.273-.113l-.319-.32a.386.386,0,0,1,.546-.546l.047.047.467-.467a.386.386,0,0,1,.546.546l-.741.74A.389.389,0,0,1,12.638,6.5Z",
    fill: "#ff6464",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242437",
    "data-name": "Path 242437",
    d: "M18.631,8.987H14.8a.386.386,0,0,1,0-.772h3.836a.386.386,0,0,1,0,.772",
    fill: "#ff6464",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242438",
    "data-name": "Path 242438",
    d: "M12.638,9.172a.388.388,0,0,1-.273-.113l-.319-.32a.386.386,0,0,1,.546-.546l.047.047.467-.467a.386.386,0,0,1,.546.546l-.741.74A.384.384,0,0,1,12.638,9.172Z",
    fill: "#ff6464",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242439",
    "data-name": "Path 242439",
    d: "M18.631,11.655H16.774a.386.386,0,0,1,0-.772h1.857a.386.386,0,0,1,0,.772",
    fill: "#ff6464",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChair);
export default __webpack_public_path__ + "static/media/chair.4154c14664c3b8f6591dd1c6ea46aa49.svg";
export { ForwardRef as ReactComponent };